/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>
/// <reference path="~/js/viz/shared/models/SelectorsModel.js"/>

(function($, Backbone) {
  "use strict";

  var ns;

  ns = window.nspace("ccc.viz.profile.models");

  /**
   * Records the data selector values representing the data set currently selected
   * by the user. The values in this model are represented in the URL.
   */
  ns.SelectorsModel = window.ccc.viz.shared.models.SelectorsModel.extend({
    propNames: ["dataTypeIds"]
  });
})(jQuery, Backbone);
